import React, { useEffect, useState }  from 'react';
import {RightOutlined, LoadingOutlined, DownOutlined, UpOutlined } from '@ant-design/icons';
import { Collapse, Modal, message, Col, Form, Input, Radio } from 'antd';
import CustomerMainLayout from '../CustomerMainLayout';
import { Button, Row, } from 'antd';
import { withRouter} from 'react-router-dom'
import ReviewCardsLinkList from './ReviewCardsLinkList';
import RequestCardLinkList from './RequestCardLinkList';
import ProductDetails from './../ProductDetailsModal';
import RoomDetails from './../RoomDetailsModal';
import ApproveScene from './../ApproveSceneModal';
import CustomerOnboarding from './../CustomerOnboarding';
import DottedLoader from '../../DottedLoader';
import axios from 'axios';
import ENVIRONMENT from '../../../../environments';
import { connect } from 'react-redux';
import {fetchDashboard, listProducts, getProductRender, fetchRoom} from '../../../../redux/actions';
import MaterialDetailModal from '../MaterialDetailModal/MaterialDetailModal';
import { MATERIAL_GET } from '../../../../environments/env';
import CollaborationCard from '../CustomerCollaborations/CollaborationCard';
import SuccessModal from '../../SuccessModal/SuccessModal';
import CollaborationModals from '../CollaborationModals/CollaborationModals';
import CustomerChangeLog from '../CustomerChangeLog/CustomerChangeLog';

const { Panel } = Collapse;

const PanelHeader = (props) => {
    return (
        <div className='homepage-panel' style={{width: "100%", display: "flex"}}>
            <div style={{marginRight: 10}} className="review-heading" data-tut={props.data_tut}>
                {props.text}
            </div>
            
        </div>
    );
}

const HomePage = (props) => {

    const [reviewAll, setReviewAll] = useState(false);
    const [requestsAll, setRequestsAll] = useState(false);
    const [productDetailsModalVisible, setProductDetailsModalVisible] = useState(false);
    const [roomDetailsModalVisible, setRoomDetailsModalVisible] = useState(false);
    const [sceneDetailsModalVisible, setSceneDetailsModalVisible] = useState(false);
    const [deleteModal, setDeleteModal] = useState(false);
    const [deleteLoader, setDeleteLoader] = useState(false);
    const [deleteEntityid, setDeleteEntityid] = useState(-1);
    const [deleteEntityType, setdDeleteEntityType] = useState('');
    const [incompleteRequest, setIncompleteRequest] = useState(false);
    const [collabRequest, setCollabRequest] = useState(false);
    const [itemId, setItemId] = useState(-1);
    const [itemType, setItemType] = useState('');
    const [onBoardingActive, setOnBoardingActive] = useState(false);
    const [onBoardingStart, setOnBoardingStart] = useState(1);
    const [reviewCount, setReviewCount] = useState(0);
    const [incompleteCount, setIncompleteCount] = useState(0);
    const [inprogressCount, setInProgressCount] = useState(0);
    const [collabCount, setCollabCount] = useState(0);
    const [materialModal, setMaterialModal] = useState(false);
    const [selectedMaterial, setSelectedMaterial] = useState('');
    const [searchValue, setSearchValue] = useState('');
    const [firstTimeLoad, setFirstTimeLoad] = useState(true);
    const [searchedReviewCount, setSearchedReviewCount] = useState(0);
    const [searchedInprogressCount, setSearchedInproressCount] = useState(0);
    const [searchedIncompleteCount, setSearchedIncompleteCount] = useState(0);
    const [searchedCollabCount, setSearchedCollabCount] = useState(0);
    const [allDataLoaded, setAllDataLoaded] = useState(false);
    const [deleteConfirmModal, setDeleteConfirmModal] = useState(false);
    const [resolveConfirmModal, setResolveConfirmModal] = useState(false);
    const [selectedCollab, setSelectedCollab] = useState(null);
    const [sharedCollabTabType, setSharedCollabTabType] = useState('all');



    useEffect(() => {
        let step_no = new URLSearchParams(window.location.search).get("step_no");
        if(step_no != undefined) {
            setOnBoardingActive(true);
            setOnBoardingStart(step_no);
        }
        let payload = {
        };

        let viewl_all_reviews = new URLSearchParams(window.location.search).get("viewl_all_reviews");
        if(viewl_all_reviews == 'true'){
            payload.reviewAll = 1;
            setReviewAll(true);
        }
        let view_all_requests = new URLSearchParams(window.location.search).get("view_all_requests");
        if(view_all_requests == 'true'){
            payload.requestsAll = 1;
            setRequestsAll(true);
        }

        let view_all_incomplete_requests = new URLSearchParams(window.location.search).get("view_all_incomplete_requests");
        if(view_all_incomplete_requests == 'true'){
            payload.incompleteAll = 1;
            setIncompleteRequest(true);
        }

        let view_all_collaborations = new URLSearchParams(window.location.search).get("view_all_collabs");
        if(view_all_collaborations == 'true'){
            payload.collabAll = 1;
           setCollabRequest(true);
        }
        if(firstTimeLoad){
            setFirstTimeLoad(false);
            let shared_entities = localStorage.getItem('shared_entities');
            let company_id = localStorage.getItem('company_id');
            if (company_id != undefined && shared_entities != undefined)
            {
                payload.company_id = company_id;
                payload.shared_entities = shared_entities;
                
            }
            props.fetchDashboardData(payload);
        }
    }, [reviewAll, requestsAll,incompleteRequest, collabRequest]);

    useEffect(() => {
        if(!firstTimeLoad && !allDataLoaded && props.rootReducer.dashboardData.entities != []){
            let payload = {
                'reviewAll': 1,
                'requestsAll': 1,
                'incompleteAll': 1,
                'collabAll': 1
            }
            let shared_entities = localStorage.getItem('shared_entities');
            let company_id = localStorage.getItem('company_id');
            if (company_id != undefined && shared_entities != undefined)
            {
                payload.company_id = company_id;
                payload.shared_entities = shared_entities;
                
            }
            props.fetchDashboardData(payload);
            setAllDataLoaded(true);
        } else if (allDataLoaded) {
            setSharedCollabTabType('scene');
        }
    }, [props.rootReducer.dashboardData.entities]);



    useEffect(() => {
        if(props.rootReducer.dashboardData.counts != undefined){
            let counts = props.rootReducer.dashboardData.counts;
            setInProgressCount(counts.inprogress_count);
            setReviewCount(counts.review_count);
            setIncompleteCount(counts.incomplete_count);
            setCollabCount(counts.collab_count);
            if(counts.products == 0 && counts.rooms == 0 && counts.scenes == 0 && counts.collections == 0 && counts.collab_count == 0){
                setOnBoardingActive(true);
                setOnBoardingStart(1);
            }
        }
    }, [props]);


    const onDelete = () => {
    
        setDeleteLoader(true);

        let api_end_point = ENVIRONMENT.DELETE_INCOMPLETE_REQUEST;
        let payload = {
            "entity_id": deleteEntityid,
            "entity_type": deleteEntityType,
        };
        
        axios.post(api_end_point, payload)
            .then( (response) => {
                message.info('Deleted.');
                window.location.href = '/home';
            })
            .catch((error) => {
                message.error('Error in deleting');
                setDeleteLoader(false);
                setDeleteModal(false);

            });
    }

    const changeSearchValue = (value) => {
        setSearchValue(value);
    }

    const triggetDeleteModel = (id, type) => {
        setDeleteEntityid(id);
        setdDeleteEntityType(type);
        setDeleteModal(true);
    }

    const onChangeSharedTabType = (e) => {
        setSharedCollabTabType(e.target.value);
    }
    

    const openMaterialModal = (material) => {
        if (material.state == "incomplete" || material.model_status == 1) {
            if (material.is_scanned) {
                window.location.href = "/upload-scanned-material/" + material.id;
            } else {
                window.location.href = "/create-new-material/" + material.id;
            }
            
        } else {
            setMaterialModal(true);
            setSelectedMaterial('');
            let payload = {
                material_id: material.id
              };
            axios.post(MATERIAL_GET, payload )
            .then(res => {
                let material_data = JSON.parse(res.data.body);
                setSelectedMaterial(material_data);
            });
        }
        
    }

    const closeMaterialModal = () => {
        setMaterialModal(false);
    }

    const getProductReviewLink = (element) => {
        setItemId(element.id);
        setItemType('product');
        let link = '#'
        if (element.model_status == "10") {
            if (element.uploaded_model) {
                link = '/upload-product-model/' + element.id;
            }
            else if (element.designed_product) {
               link = '/add-new-product/' + element.id;
            } else {
                link = '/create-existing-physical-product/' + element.id;
            }
        }
        else if (element.is_configurable == "true") {
            link = '/add-configurations/' + element.id;
        } else {
            link = '/product-qa/' + element.id;
        }

        return link
    }

    const getRoomReviewLink = (itemId) => {
        setItemId(itemId);
        setItemType('room');
        let link = '/rooms/' + itemId;

        return link
    }

    const getSceneReviewLink = (itemId) => {
        setItemId(itemId);
        setItemType('scene');
        let link = '#'
        if(onBoardingActive){
            link = '/approve_scene/' + itemId + '?onboarding=true'
        }
        else{
            link = '/approve_scene/' + itemId
        }

        return link
    }

    const viewAllReviews = () => {
        setReviewAll(true);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=true&view_all_requests=${requestsAll}&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=${collabRequest}`
        });
    }
    

    const viewAllRequests = () => {
        setRequestsAll(true);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=true&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=${collabRequest}`
        });
    }
    const viewAllIncompleteRequests = () => {
        setIncompleteRequest(true);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=${requestsAll}&view_all_incomplete_requests=true&view_all_collabs=${collabRequest}`
        });
    }

    const viewAllCollabRequests = () => {
        setCollabRequest(true);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=${requestsAll}&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=true`
        });
    }

    const closeAllCollabRequests = () => {
        setCollabRequest(false);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=${requestsAll}&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=false`
        });
    }

    const closeAllReviews = () => {
        setReviewAll(false);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=false&view_all_requests=${requestsAll}&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=${collabRequest}`
        });
    }

    const closeAllRequests = () => {
        setRequestsAll(false);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=false&view_all_incomplete_requests=${incompleteRequest}&view_all_collabs=${collabRequest}`
        });
    }

    const closeAllIncomplete = () => {
        setIncompleteRequest(false);
        props.history.push({
            pathname: '/home',
            search: `?viewl_all_reviews=${reviewAll}&view_all_requests=${requestsAll}&view_all_incomplete_requests=false&view_all_collabs=${collabRequest}`
        });
    }

    const addKeywordsInHomePageData = (objects) => {
        let result = objects.map(obj => {
            let keywords = []
            
            if(obj.id){
                keywords.push(obj.id)
            }

            for(let keyword of obj.name.replace(/[^a-zA-Z0-9 ]/g, " ").split(" ")) {
              if (!keywords.includes(keyword)) {
                if (keyword.length > 1) {
                  keywords.push(keyword.toLowerCase())
                }
              }
            }

            if (obj.gtin) {
                keywords.push(obj.gtin.toLowerCase())
            }

            if (obj.category){
                for(let keyword of obj.category.replace(/[^a-zA-Z0-9 ]/g, " ").split(" ")) {
                    if (!keywords.includes(keyword)) {
                        if (keyword.length > 1) {
                            keywords.push(keyword.toLowerCase())
                        }
                    }
                }
            }

            if (obj.style) {
                keywords.push(obj.style.toLowerCase())
            }

            if (obj.tags && obj.tags.length > 1) {
                obj.tags.map(keyword => {
                    if (!keywords.includes(keyword)) {
                        if (keyword.length > 1) {
                            // should we split tags or not?
                            keywords = keywords.concat(keyword.toLowerCase().split(" "))
                            // keywords.push(keyword.toLowerCase())  
                        }
                    }
                })
            }
            return { ...obj, 'keywords': keywords };
          });
          return result
    }


    const openDeleteCollaboration = (element) => {
        setSelectedCollab(element);
        setDeleteConfirmModal(true);
    }

    const openMarkCollaborationAsResolved = (element) => {
        setResolveConfirmModal(true);
        setSelectedCollab(element);
    }

    const getCollaborationData = () => {
        let collaborations = addKeywordsInHomePageData(props.rootReducer.dashboardData.entities.filter((ele) => ele.state == 'collaborations'));
        if (sharedCollabTabType == 'product') {
            collaborations = collaborations.filter((ele) => ele.type == 'product')
        } else if (sharedCollabTabType == 'scene') {
            collaborations = collaborations.filter((ele) => ele.type == 'scene')
        }
        return collaborations;
    }

    return <CustomerMainLayout selected='9'>
        <div className='bg-color color-6b'>
      {((props.rootReducer.dashboardData.entities && props.rootReducer.dashboardData.entities.length != 0) || !props.rootReducer.isLoading) ? 
      (props.rootReducer.dashboardData.entities && props.rootReducer.dashboardData.entities.length != 0) ?
      <div>
          <Row className="justify-space-between bg-color color-6b" style={{margin:"20px 0px"}}>              
            <Col> 
                <div className='manrope f-24 w-700' style={{display:'flex',alignItems:"flex-end"}}><span>Home</span></div>

            </Col>
            <Col  lg={10} xl={10}>
                <Form>
                <Input.Group compact size="large" className="d-inline">
                    <Input placeholder="Search Home Page" onChange={e => {changeSearchValue(e.target.value)}} className="manrope f-14 mat-search-bar"></Input>
                </Input.Group>
                </Form>
            </Col>
        </Row>
      <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            ghost
            className="collapse-panel bg-grey"
            expandIconPosition="right"
        >
            <Panel header={<PanelHeader text={<span className="manrope f-16 w-500 black-33">Review <span className="manrope grey-73">({searchValue != '' ? searchedReviewCount : reviewCount})</span></span>} data_tut="reactour__review"></PanelHeader>} key="1" className="bg-color color-6b">
                <Row type="flex" style={{ justifyContent: "start",paddingTop: 16  }}>
                    <ReviewCardsLinkList
                    products={addKeywordsInHomePageData(props.rootReducer.dashboardData.entities.filter((ele) => ele.state == 'review').sort((a, b) => a['type'].localeCompare(b['type'])))}
                    link={`/products/`}
                    searchValue={searchValue}
                    setSearchedReviewCount={setSearchedReviewCount}
                    expanded={reviewAll}
                    getProductReviewLink = {getProductReviewLink}
                    getRoomReviewLink = {getRoomReviewLink}
                    getSceneReviewLink = {getSceneReviewLink}
                    />
                </Row>
                { ((searchValue == '' && reviewCount > 4) && (reviewAll == false || props.rootReducer.isLoading)) || (searchValue != '' && searchedReviewCount > 4 && reviewAll == false) ?
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => viewAllReviews()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View More {(reviewAll && props.rootReducer.isLoading) ? <LoadingOutlined spin /> : <DownOutlined/>}
                    </Button>
                </div>: (searchValue == '' && reviewCount > 4 && reviewAll) || (searchValue != '' && searchedReviewCount > 4 && reviewAll) ? 
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => closeAllReviews()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View Less <UpOutlined/>
                    </Button>
                </div>
                :
                ''
                }
            </Panel>
        </Collapse>

        {props.rootReducer.dashboardData.entities.filter((ele) => ele.state == 'collaborations').length == 0 ? '' :
        <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            ghost
            className="collapse-panel bg-grey"
            expandIconPosition="right"
        >
            <Panel header={<PanelHeader text={<span className="manrope f-16 w-500 black-33">Collaborations <span className="manrope grey-73">({searchValue != '' ? searchedCollabCount : collabCount})</span></span>} 
            data_tut="reactour__review"></PanelHeader>} 
            key="1" className="bg-color color-6b">
                <>
                <Row style={{ paddingTop: 16 }}>
                    <div className="shared-models-tab manrope f-14 black-55">
                        <span className="shared-models-tab-span">
                            Show Items:
                        </span>
                        <Radio.Group onChange={onChangeSharedTabType} value={sharedCollabTabType}>
                            <Radio value='all'>
                                All
                            </Radio>
                            <Radio value='product'>
                                Products
                            </Radio>
                            <Radio value='scene'>
                                Scene Lifesyle Images
                            </Radio>
                        </Radio.Group>
                    </div>
                </Row>
                {getCollaborationData().length > 0 ?
                <Row type="flex" style={{ justifyContent: "start",paddingTop: 8  }}>
                    <CollaborationCard
                    searchValue={searchValue}
                    type={'unresolved'}
                    homepage={true}
                    expanded={collabRequest}
                    setSearchedCollabCount={setSearchedCollabCount}
                    collaborations={getCollaborationData()}
                    openMarkCollaborationAsResolved={openMarkCollaborationAsResolved}
                    openDeleteCollaboration={openDeleteCollaboration}
                    />
                   
                </Row> :
                <div className="empty-section" style={{ padding: "10px 0", position: "relative", textAlign: '-webkit-center' }}>
                    <img id="empty-section-image" style={{ width: "10%" }} src="../../../../img/Spaces.svg" />
                    <p className="empty-section-text manrope f-14 black-55">
                        Nothing to show
                    </p>
                    <p style={{ marginTop: "-1%" }} className="empty-section-text manrope f-12 grey-6b">
                        There are no unresolved collaborations.
                    </p>
                </div>}
                { (getCollaborationData().length > 0 && ((searchValue == '' && collabCount > 4) && (collabRequest == false || props.rootReducer.isLoading)) || (searchValue != '' && searchedCollabCount > 4 && collabRequest == false)) ?
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => viewAllCollabRequests()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View More {(collabRequest && props.rootReducer.isLoading) ? <LoadingOutlined spin /> : <DownOutlined/>}
                    </Button>
                </div>: (getCollaborationData().length > 0 && (searchValue == '' && collabCount > 4 && collabRequest) || (searchValue != '' && searchedCollabCount > 4 && collabRequest)) ? 
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => closeAllCollabRequests()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View Less <UpOutlined/>
                    </Button>
                </div>
                :
                ''
                
                }</>
            </Panel>
        </Collapse>}

        <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            ghost
            className="collapse-panel bg-grey"
            expandIconPosition="right"
        >
            <Panel header={<PanelHeader text={<span className="manrope f-16 w-500 black-33">In Progress Requests <span className="manrope grey-73">({searchValue != '' ? searchedInprogressCount : inprogressCount})</span></span>} data_tut="reactour__inprogress"></PanelHeader>} key="1" className="bg-color color-6b">
                <Row type="flex" style={{ justifyContent: "start",paddingTop: 16  }}>
                    <RequestCardLinkList
                    openMaterialModal={openMaterialModal}
                    searchValue={searchValue}
                    expanded={requestsAll}
                    setSearchedInproressCount={setSearchedInproressCount}
                    state='awaiting'
                    products={addKeywordsInHomePageData(props.rootReducer.dashboardData.entities.filter((ele) => ele.state == 'awaiting'))}
                    showDeletedModelOption={false}
                    setDeleteModal={triggetDeleteModel}
                    />
                    
                </Row>
                { ((searchValue == '' && inprogressCount > 4) && (requestsAll == false || props.rootReducer.isLoading)) || (searchValue != '' && searchedInprogressCount > 4 && requestsAll == false) ?
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => viewAllRequests()}  type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600"   size="large">
                       View More {(requestsAll && props.rootReducer.isLoading) ? <LoadingOutlined spin /> : <DownOutlined/>}
                    </Button>
                </div>
                : (searchValue == '' && inprogressCount > 4 && requestsAll) || (searchValue != '' && searchedInprogressCount > 4 && requestsAll) ? 
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => closeAllRequests()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View Less <UpOutlined/>
                    </Button>
                </div> :''
                }
            </Panel>
        </Collapse>

        <Collapse
            bordered={false}
            defaultActiveKey={['1']}
            ghost
            className="collapse-panel bg-grey"
            expandIconPosition="right"
        >
            <Panel header={<PanelHeader text={<span className="manrope f-16 w-500 black-33">Incomplete Requests <span className="manrope grey-73">({searchValue != '' ? searchedIncompleteCount : incompleteCount})</span></span>} data_tut="reactour__incomplete"></PanelHeader>} key="1" className="bg-color color-6b">
                <Row type="flex" style={{ justifyContent: "start",paddingTop: 16 }}>
                    <RequestCardLinkList
                    openMaterialModal={openMaterialModal}
                    searchValue={searchValue}
                    expanded={incompleteRequest}
                    setSearchedIncompleteCount={setSearchedIncompleteCount}
                    state='incomplete'
                    products={addKeywordsInHomePageData(props.rootReducer.dashboardData.entities.filter((ele) => ele.state == 'incomplete'))}
                    setDeleteModal={triggetDeleteModel}
                    showDeletedModelOption={true}
                    />
                    
                </Row>
                { ((searchValue == '' && incompleteCount > 4) && (incompleteRequest == false || props.rootReducer.isLoading)) || (searchValue != '' && searchedIncompleteCount > 4 && incompleteRequest == false)?
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => viewAllIncompleteRequests()}  type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600"  size="large">
                       View More {(incompleteRequest && props.rootReducer.isLoading) ? <LoadingOutlined spin /> : <DownOutlined/>}
                    </Button>
                </div>
                : (searchValue == '' && incompleteCount > 4 && incompleteRequest) || (searchValue != '' && searchedIncompleteCount > 4 && incompleteRequest) ? 
                <div style={{display: 'flex', justifyContent: "space-around",paddingBottom: 20}}>
                    <Button onClick={() => closeAllIncomplete()} type="danger d-inline" shape="round" className="outline-red-btn square font-14 w-600" size="large">
                        View Less <UpOutlined/>
                    </Button>
                </div> 
                
                :''
                }
            </Panel>
        </Collapse>

        
      </div>
      :
      <div>
        <Row className="justify-space-between bg-color color-6b" style={{margin:"40px 0px"}}>            
            <Col> 
                <div className='manrope f-24 w-900' style={{display:'flex',alignItems:"flex-end"}}><span>Home</span></div>

            </Col>
        </Row>
        <div className='shadow'>
            <img class="logo" src="../../../../img/Home 2.svg" />
            <div className='text-home-page-default'>
                <p className="text-welcome manrope f-14 black-55">
                    Welcome to ALL3D!
                </p>
                <p style={{textWrap: "balance", maxWidth:"80%", position:"relative", left:"10%",marginTop:"-8px"}} className="manrope f-12 grey-6b">
                    We're super excited to have you here. To get started, click on the create new button.
                </p>
            </div>
        </div>
      </div>
      :
      <DottedLoader/>}
      </div>
      <Modal
          title="Product QA"
          visible={productDetailsModalVisible}
          onOk={() => setProductDetailsModalVisible(false)}
          onCancel={() => setProductDetailsModalVisible(false)}
          footer={[
          ]}
          width= "98%"
          style={{top: 4}}
          destroyOnClose={true}
          bodyStyle={{padding: 0}}
        >
            <ProductDetails itemId={itemId} props={props}/>
        </Modal>
        <Modal
          title="Space QA"
          visible={roomDetailsModalVisible}
          onOk={() => setRoomDetailsModalVisible(false)}
          onCancel={() => setRoomDetailsModalVisible(false)}
          footer={[
          ]}
          width= "98%"
          style={{top: 4}}
          destroyOnClose={true}
          bodyStyle={{padding: 0}}
        >
            <RoomDetails itemId={itemId} props={props}/>
        </Modal>
        <Modal
          title="Scene QA"
          visible={sceneDetailsModalVisible}
          onOk={() => setSceneDetailsModalVisible(false)}
          onCancel={() => setSceneDetailsModalVisible(false)}
          footer={[
          ]}
          width= "98%"
          style={{top: 4}}
          destroyOnClose={true}
          bodyStyle={{padding: 0}}
        >
            <ApproveScene itemId={itemId} props={props}/>
        </Modal>
        <Modal
        className="silo-success-modal"
        width={800}
        centered={true}
          visible={deleteModal}
          closable={false}
          footer={[
              <span className="justify-in-center">
                  <Button key="back" style={{textAlign:"center"}} className="modal-okay-gray square font-14" onClick={() => setDeleteModal(false)}>
                      Cancel
                  </Button>
                  <Button key="back" style={{textAlign:"center"}} className="modal-okay square font-14" onClick={() => onDelete()}>
                      {deleteLoader? <span> Deleting <LoadingOutlined spin /></span>:<span> Yes, Delete {deleteEntityType} </span>}
                  </Button>
              </span>
          ]}
          > 
            <div style={{margin:"30px auto 0px auto",textAlign:"center",display:"flex",flexDirection:"column",justifyContent:"center",alignItems:"center"}}>
                <h2 className="manrope f-24 black-55 w-900">{'You are about to delete a ' + deleteEntityType + ' Request'}</h2>
                <p className="manrope f-18 black-33">Are you sure you want to delete this request?</p>
            </div>   
        </Modal>
       <CollaborationModals
        homepage={true}
        resolveConfirmModal={resolveConfirmModal}
        setResolveConfirmModal={setResolveConfirmModal}
        setSelectedCollab={setSelectedCollab}
        selectedCollab={selectedCollab}
        setDeleteConfirmModal={setDeleteConfirmModal}
        deleteConfirmModal={deleteConfirmModal}
       />
     
        <MaterialDetailModal
            materialModal={materialModal}
            closeMaterialModal={closeMaterialModal}
            selectedMaterial={selectedMaterial}
            editable={false}
            errorMessage={''}
        />

        {(onBoardingActive)?
        <CustomerOnboarding step_no={onBoardingStart}/>
         :""}
        {(onBoardingActive) ? '' : <CustomerChangeLog />}
    </CustomerMainLayout>
};
const mapStateToProps = state => state;

const mapDispatchToProps = dispatch => ({
    fetchDashboardData: (payload) => {
        dispatch(fetchDashboard(payload));
    },
    listProducts: () => {
        dispatch(listProducts());
    },
    getProduct: (product) => {
        dispatch(getProductRender(product));
    },
    getRoom: (payload) => {
        dispatch(fetchRoom(payload))
    }
});

export default withRouter(connect(
    mapStateToProps,
    mapDispatchToProps
)(HomePage))